import { actions } from '../constants/storageManagement';
import * as actionTypes from '../../models/action/assignment';
import { Log } from 'ng2-logger';
import { IAction } from '../../models/action/core';
import {
    IStorageManagementPage,
    IFilesAddedActivities,
    IActivityFilesStatisticsByTerm,
    IFilterAddedActivityFile,
    IFilterAddedCommunicationFile,
    IFilterPersonelFile,
    IFilterOtherFile
} from '../../models/components/storage-management';
import { IPagedQueryS } from '../../models/components/paginate';
import { ISetAssignmentStudentList, IAssignmentStudentList } from '../../models/action/assignment';

export function GeneralStatistics(spinnerId?: string, spinnerType?: 'get' | 'set'): any {
    return {
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.GET_GENERAL_STATISTICS
    };
}

export function SetGeneralStatistics(storageManagementPage: Array<IStorageManagementPage>, spinnerId?: string, spinnerType?: 'get' | 'set'): any {
    return {
        storageManagementPage,
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.SET_GENERAL_STATISTICS
    };
}

export function FilesAddedActivitiesStatistics(spinnerId?: string, spinnerType?: 'get' | 'set'): any {
    return {
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.GET_FILES_ADDED_ACTIVITIES_STATISTICS
    };
}

export function SetFilesAddedActivitiesStatistics(filesAddedActivities: Array<IFilesAddedActivities>, spinnerId?: string, spinnerType?: 'get' | 'set'): any {
    return {
        filesAddedActivities,
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.SET_FILES_ADDED_ACTIVITIES_STATISTICS
    };
}

export function ActivityFilesStatisticsByTerm(termId?: string, spinnerId?: string, spinnerType?: 'get' | 'set', callback?: () => void): any {
    return {
        termId,
        spinnerId,
        spinnerType,
        callback,
        timestamp: Date.now(),
        type: actions.GET_ACTIVITY_FILES_STATISTICS_BYTERM
    };
}

export function SetActivityFilesStatisticsByTerm(activityFilesStatisticsByTerm: Array<IActivityFilesStatisticsByTerm>, spinnerId?: string, spinnerType?: 'get' | 'set'): any {
    return {
        activityFilesStatisticsByTerm,
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.SET_ACTIVITY_FILES_STATISTICS_BYTERM
    };
}

export function ActivityFilesListByTerm(filters: IFilterAddedActivityFile, paging: IPagedQueryS, spinnerId?: string, spinnerType?: 'get' | 'set', callback?: () => void): any {
    return {
        filters,
        paging,
        spinnerId,
        spinnerType,
        callback,
        timestamp: Date.now(),
        type: actions.GET_ACTIVITY_FILES_LIST_BYTERM,
    };
}

export function SetActivityFilesListByTerm(activityFilesListByTerm: Array<any>, tabName?: string, spinnerId?: string, spinnerType?: 'get' | 'set'): any {
    return {
        activityFilesListByTerm,
        tabName,
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.SET_ACTIVITY_FILES_LIST_BYTERM
    };
}

export function DeleteActivityFiles(
    selectedIds: Array<string>,
    callback: () => void,
    unselectedIds?: Array<string>,
    spinnerId?: string,
    spinnerType?: 'get' | 'set',
    objectTypes:number = 0,
    ownerName:string = '',
    fileType:string = '',
    fileDate:string = '',
    fileOwner:string ='',
    fileName:string = '',
    tabName:string = '',
    isDeleted:boolean = false,
    termId:string = '',
    listName:string = '',
    isAllSelected:boolean = false,): any {
    return {
        selectedIds,
        callback,
        unselectedIds,
        spinnerId,
        spinnerType,
        objectTypes,
        ownerName,
        fileType,
        fileDate,
        fileOwner,
        fileName,
        tabName,
        isDeleted,
        termId,
        listName,
        isAllSelected,
        timestamp: Date.now(),
        type: actions.DELETE_ACTIVITY_FILES
    };
}

export function DownloadActivityFiles(
    selectedIds: Array<string>,
    callback: () => void,
    spinnerId?: string,
    spinnerType?: 'get' | 'set'): any {
    return {
        selectedIds,
        callback,
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.DOWNLOAD_ACTIVITY_FILES
    };
}

export function CommunicationFilesList(filters: IFilterAddedCommunicationFile, paging: IPagedQueryS, spinnerId?: string, spinnerType?: 'get' | 'set'): any {
    return {
        filters,
        paging,
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.GET_COMMUNICATION_FILES_LIST
    };
}

export function SetCommunicationFilesList(communicationFilesList: Array<any>, spinnerId?: string, spinnerType?: 'get' | 'set'): any {
    return {
        communicationFilesList,
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.SET_COMMUNICATION_FILES_LIST
    };
}

export function CommunicationFilesStatistics(spinnerId?: string, spinnerType?: 'get' | 'set', callback?: () => void): any {
    return {
        spinnerId,
        spinnerType,
        callback,
        timestamp: Date.now(),
        type: actions.GET_COMMUNICATION_FILES_STATISTICS
    };
}

export function SetCommunicationFilesStatistics(communicationFilesStatistics: Array<any>, spinnerId?: string, spinnerType?: 'get' | 'set'): any {
    return {
        communicationFilesStatistics,
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.SET_COMMUNICATION_FILES_STATISTICS
    };
}

export function PersonelFilesList(filters: IFilterPersonelFile, paging: IPagedQueryS, spinnerId?: string, spinnerType?: 'get' | 'set', callback?: () => void): any {
    return {
        filters,
        paging,
        spinnerId,
        spinnerType,
        callback,
        timestamp: Date.now(),
        type: actions.GET_PERSONEL_FILES_LIST
    };
}

export function SetPersonelFilesList(personelFilesList: Array<any>, spinnerId?: string, spinnerType?: 'get' | 'set'): any {
    return {
        personelFilesList,
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.SET_PERSONEL_FILES_LIST
    };
}

export function RestoreActivityFiles(
    selectedIds: Array<string>,
    callback: () => void,
    spinnerId?: string,
    spinnerType?: 'get' | 'set'): any {
    return {
        selectedIds,
        callback,
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.RESTORE_ACTIVITY_FILES
    };
}

export function OtherFilesList(filters: IFilterOtherFile, paging: IPagedQueryS, spinnerId?: string, spinnerType?: 'get' | 'set',  callback?: () => void): any {
    return {
        filters,
        paging,
        spinnerId,
        spinnerType,
        callback,
        timestamp: Date.now(),
        type: actions.GET_OTHER_FILES_LIST
    };
}

export function SetOtherFilesList(otherFilesList: Array<any>, spinnerId?: string, spinnerType?: 'get' | 'set'): any {
    return {
        otherFilesList,
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.SET_OTHER_FILES_LIST
    };
}